export default function Configure($stateProvider) {
    $stateProvider.state('livraison-planifiee-livree', {
        parent: 'gestion',
        url: '/livraison-planifiee-livree',
        views: {
            gestion: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.TRANSPORT" | translate }}'
        }
    });

    $stateProvider.state('livraison-planifiee-livree.list', {
        url: '/list',
        template: '<livraison-planifiee-livree></livraison-planifiee-livree>',
        rights: { domain: 'dmdlivrs', right: 'read' },
        ncyBreadcrumb: {
            parent: 'livraison-planifiee-livree',
            label: '{{ "LIVRAISON_PLANIFIEE_LIVREE.BREADCRUMBS.LIVRAISON_PLANIFIEE_LIVREE" | translate}}'
        },
        navigation: {
            menu: 'transport_plannings',
            translate: 'LIVRAISON_PLANIFIEE_LIVREE.BREADCRUMBS.LIVRAISON_PLANIFIEE_LIVREE',
            order: 15
        },
        search: 'LIVRAISON_PLANIFIEE_LIVREE.BREADCRUMBS.LIVRAISON_PLANIFIEE_LIVREE'
    });
}

Configure.$inject = ['$stateProvider'];
